import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uistyle-guide"
    }}>{`@theme-ui/style-guide`}</h1>
    <p>{`Component for rendering Theme UI styles in a style guide format.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/style-guide
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Themed } from 'theme-ui'
import { TypeScale, TypeStyle, ColorPalette } from '@theme-ui/style-guide'

export default (props) => (
  <>
    <Themed.h1>Style Guide</Themed.h1>
    <ColorPalette />
    <TypeScale />
    <TypeStyle fontFamily="heading" fontWeight="heading" lineHeight="heading" />
    <TypeStyle fontFamily="body" fontWeight="body" lineHeight="body" />
  </>
)
`}</code></pre>
    <p>{`See the `}<inlineCode parentName="p">{`gatsby-theme-style-guide`}</inlineCode>{` package for easier integration with Gatsby.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      